import { ArrowUp, ArrowDown } from 'lucide-react';

/**
 * Small ▲/▼ chip showing how many ranks a player moved this week.
 * Renders nothing when there's no meaningful change (same / new / unranked).
 */
export const StandingMovement = ({ standing, className = '' }) => {
  if (!standing || !standing.change || standing.change_dir === 'same' || standing.change_dir === 'new') {
    return null;
  }
  const up = standing.change_dir === 'up';
  const n = Math.abs(standing.change);
  const Icon = up ? ArrowUp : ArrowDown;
  return (
    <span
      title={`${up ? 'Up' : 'Down'} ${n} this week`}
      data-testid="standing-movement"
      className={`inline-flex items-center gap-0.5 text-xs font-bold ${up ? 'text-green-600' : 'text-red-500'} ${className}`}
    >
      <Icon className="w-3 h-3" strokeWidth={3} />{n}
    </span>
  );
};

export default StandingMovement;
